export interface ScormTheme {
    accent: string;
}

export const scormTheme: ScormTheme = {
    accent: "#012126", // accent backgroundcolor for scorm mobile bottom footer bar
}